// extracted by mini-css-extract-plugin
export var animationContainer = "_gt-0";
export var asteriskIcon = "_gt-8";
export var conversationLeftSection = "_gt-4";
export var conversationListItem = "_gt-3";
export var conversationMiddleSection = "_gt-5";
export var conversationRightSection = "_gt-6";
export var detailsContent = "_gt-1";
export var listContainer = "_gt-7";
export var modalContent = "_gt-2";